<div *ngIf="hasItems; else playersEmpty">
  <div *ngIf="keplerPlayerTableListService.mode === 'view'">
    <lms-toolbar [options]="toolbarConfig">
      <div class="lms-toolbar__item" *lmsProfileGuard="'kepler.player.create'" tools-actions>
        <span class="lmstooltip">
          <gl-button
            color-primary
            title="{{ (didMatchEnd ? null : 'kepler.playersAdd') | translate }}"
            [text]="'kepler.playersAdd' | translate"
            (onClick)="openCsvModal()"
            [tooltip]="didMatchEnd ? ('kepler.tooltipButtonPlayers' | translate) : ''"
            [tooltipLeft]="true"
            [disabled]="didMatchEnd"
          ></gl-button>
        </span>
      </div>
    </lms-toolbar>
    <div class="gl-table__container">
      <div *ngIf="selectable && isAnySelected">
        <div class="lms-toolbar__secondary" [ngClass]="{ hidden: !isAnySelected }" tools-actions>
          <div class="list-counter">
            <span>
              {{ selectAll ? dataSource.total - excludedPlayers.size : selectedPlayers.length }}
              {{
                (selectedPlayers.length === 1 ? 'kepler.player.bulk.selectedSingle' : 'kepler.player.bulk.selected')
                  | translate
              }}
            </span>
            <a
              (click)="setSelectAll(true)"
              *ngIf="!selectAll"
              title="{{ 'kepler.player.bulk.selectAll' | translate : { total: dataSource.total } }}"
              >{{ 'kepler.player.bulk.selectAll' | translate : { total: dataSource.total } }}
            </a>
          </div>
          <div class="actions">
            <ng-container>
              <lms-button-actions
                id="kepler_player_list_bulk_actions"
                class="margin-half-right margin-half-left"
                [items]="actionItems"
                (change)="selectAction($event)"
              ></lms-button-actions>
            </ng-container>
            <div class="border-left padding-left margin-left-8">
              <gl-button
                color-secondary
                small
                [text]="'actions.cancelSelection' | translate"
                (onClick)="setSelectAll(false)"
              >
              </gl-button>
            </div>
          </div>
        </div>
      </div>
      <gl-table
        #playersTable
        [id]="keplerPlayerListId"
        [dataSource]="dataSource"
        data-testid="playersTable"
        [placeholder]="'actions.noResultTable' | translate"
        [attr.disableHeaderSelector]="selectAll ? true : null"
        [attr.selectable]="selectable ? true : null"
        paginator
        disableHeaderSelector
        (onSelectionChanged)="onSelectionChanged($event.detail)"
        (onRowSelectionChanged)="onRowSelectionChanged($event.detail)"
        (onFiltersChanged)="onFiltersChanged()"
        (onDatasourceUpdate)="onDatasourceUpdate()"
      >
      </gl-table>
    </div>
  </div>
  <div *ngIf="keplerPlayerTableListService.mode === 'progress'">
    <lms-kepler-player-progress-list [player]="keplerPlayerTableListService.player"></lms-kepler-player-progress-list>
  </div>
  <div *ngIf="keplerPlayerTableListService.mode === 'edit' && client">
    <lms-kepler-player-editor
      [player]="keplerPlayerTableListService.player"
      [client]="client"
      [match]="match"
      (playerUpdated)="changeView()"
    >
      <gl-button
        color-secondary
        [text]="'actions.cancel' | translate"
        (onClick)="cancelEditPlayer()"
        form-actions-before
      ></gl-button>
    </lms-kepler-player-editor>
  </div>
</div>
<ng-template #playersEmpty>
  <div class="main__void">
    <div class="main__void--icon">
      <span class="glicon-gamer"></span>
    </div>
    <span class="main__void--title">{{ 'kepler.playersVoidTitle' | translate }}</span>
    <span class="main__void--subtitle">{{ 'kepler.playersVoidSubtitle' | translate }}.</span>
    <span class="lmstooltip" *lmsProfileGuard="'kepler.player.create'">
      <gl-button
        color-primary
        title="{{ (didMatchEnd ? null : 'kepler.playersAdd') | translate }}"
        [text]="'kepler.playersAdd' | translate"
        (onClick)="openCsvModal()"
        [tooltip]="didMatchEnd ? ('kepler.tooltipButtonPlayers' | translate) : ''"
        [disabled]="didMatchEnd"
      ></gl-button>
    </span>
  </div>
</ng-template>

<lms-personalized-email
  #personalizedEmail
  [adminData]="user"
  [count]="selectAll ? listOptions.total - selectedPlayers.length : selectedPlayers.length"
  (sendEmail)="sendEmail($event)"
></lms-personalized-email>

<lms-modal #modalCsvUpload size="medium">
  <lms-csv-import
    [isKepler]="true"
    [title]="'kepler.playersAdd'"
    [buttonText]="'kepler.playersAdd'"
    (closeModal)="closeCsvModal()"
    (onSaveCsvData)="onSaveCsv($event)"
  >
    <div class="gl-popup__customHeadContent">
      <div>{{ 'kepler.csv.subtitle' | translate }}</div>
      <div>
        1. <a (click)="downloadCsv()">{{ 'kepler.csv.step1' | translate }}</a>
      </div>
      <div>2. {{ 'kepler.csv.step2' | translate }}</div>
      <div>3. {{ 'kepler.csv.step3' | translate }}</div>
    </div>
  </lms-csv-import>
</lms-modal>
